/**
 *
 * Notes: May, 2019
 * Original source code pulled (and edited) from previous website.
 * Assuming this was custom developed by previous vendor since license was not provided.
 *
 */

import $ from 'jquery';
import utils from './utils';

export default CreditCalculator;

function CreditCalculator (o) {

    let $container = $(o),
        $form = null,
        $borrowed = null,
        $rate = null,
        $payment = null,
        $months = null,
        $amount = null,
        $interest = null;

    $form = $container.find("form");
    $borrowed = $form.find("input[name=borrowed]");
    $rate = $form.find("input[name=rate]");
    $payment = $form.find("input[name=payment]");

    $months = $form.find("input[name=months]");
    $amount = $form.find("input[name=amount]");
    $interest = $form.find("input[name=interest]");

    $form.submit(function(e) {
        $form.find('.calc-results').removeClass('hidden');
        let total1,
            total2,
            P = Number($borrowed.val().replace("$","")),
            r = Number($rate.val().replace("%", ""))/100,
            mp = Number($payment.val().replace("$","")),
            computed;

        computed = Math.ceil(utils.numPayments(P, r, mp) * mp);

        total1 = Math.ceil(utils.numPayments(P, r, mp));
        total2 = Math.round(computed - P);

        $months.val((isNaN(total1)) ? 0 : total1);
        $amount.val((isNaN(computed)) ? 0 : computed);
        $interest.val((isNaN(total2)) ? 0 : total2);
        $amount.currency();
        $interest.currency();

        e.preventDefault();
        return false;

    });

    $container.find("button[type='reset']").on('click',function(){
        $('.calc-results').addClass('hidden');
        $borrowed.focus();
    });

}


// WEBPACK FOOTER //
// ./src/calculators/credit-calculator.js